import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, opacity = 1, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}px`}
    width={`${size}px`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g stroke={color} opacity={opacity} strokeWidth="2" fill="none" fillRule="evenodd">
      <path d="M4.251 13.997a8 8 0 1 0 0-3.993" />
      <path d="M12 7v5h3M3 6l1 4 4-1" />
    </g>
  </svg>
);
